import { BrowserRouter, Routes, Route } from 'react-router-dom';
import LoginPage from '../components/LoginPage';
import DashboardPage from '../components/Dashboard';
import RequestEvaluationPage from '../components/RequestEvaluation';
import DraftQuotePage from '../components/DraftQuote';
import QuoteEvaluationPage from '../components/QuoteEvaluation';
import QuoteTrackingPage from '../components/QuoteMailTracking';
import OrderInvoiceComparisonPage from '../components/OrderInvoiceComparison';
import QuoteDocumentPage from '../components/QuoteDocument';
import ReviseQuoteDocumentPage from '../components/ReviseQuoteDocument';
import ProductInquiryPage from '../components/ProductInquiry';
import PurchaseOrderPage from '../components/PurchaseOrder';
import NegotiationQuotePage from '../components/NegotiationQuote';
import CreateRequestPage from '../components/CreateRequest';
import RequestTrackingPage from '../components/RequestTracking';
import RequestInfoPage from '../components/RequestInfo';
import ItemQuoteReportPage from '../components/ItemQuoteReport';
import ProtectedRoute from '../components/ProtectedRoute';
import { USER_ROLES } from '../constants';

export const AppRoutes = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/dashboard" element={
          <ProtectedRoute allowedRoles={[USER_ROLES.ADMIN, USER_ROLES.USER, USER_ROLES.PURCHASER]}>
            <DashboardPage />
          </ProtectedRoute>
        } />
        <Route path="/request-evaluation" element={
          <ProtectedRoute allowedRoles={[USER_ROLES.ADMIN, USER_ROLES.PURCHASER]} fallbackPath="/dashboard">
            <RequestEvaluationPage />
          </ProtectedRoute>
        } />
        <Route path="/draft-quote" element={
          <ProtectedRoute allowedRoles={[USER_ROLES.ADMIN, USER_ROLES.USER, USER_ROLES.PURCHASER]} fallbackPath="/dashboard">
            <DraftQuotePage />
          </ProtectedRoute>
        } />
        <Route path="/quote-tracking" element={
          <ProtectedRoute allowedRoles={[USER_ROLES.ADMIN, USER_ROLES.PURCHASER]} fallbackPath="/dashboard">
            <QuoteTrackingPage />
          </ProtectedRoute>
        } />
        <Route path="/quote-evaluation" element={
          <ProtectedRoute allowedRoles={[USER_ROLES.ADMIN, USER_ROLES.PURCHASER]} fallbackPath="/dashboard">
            <QuoteEvaluationPage />
          </ProtectedRoute>
        } />
        <Route path="/order-invoice-comparison" element={
          <ProtectedRoute allowedRoles={[USER_ROLES.ADMIN, USER_ROLES.PURCHASER]} fallbackPath="/dashboard">
            <OrderInvoiceComparisonPage />
          </ProtectedRoute>
        } />
        <Route path="/quote-document/:publicId" element={
          <QuoteDocumentPage />
        } />
        <Route path="/revise-quote-document/:publicId" element={
          <ReviseQuoteDocumentPage />
        } />
        <Route path="/product-inquiry" element={
          <ProtectedRoute allowedRoles={[USER_ROLES.ADMIN, USER_ROLES.USER, USER_ROLES.PURCHASER]} fallbackPath="/dashboard">
            <ProductInquiryPage />
          </ProtectedRoute>
        } />
        <Route path="/purchase-order" element={
          <ProtectedRoute allowedRoles={[USER_ROLES.ADMIN, USER_ROLES.PURCHASER]} fallbackPath="/dashboard">
            <PurchaseOrderPage />
          </ProtectedRoute>
        } />
        <Route path="/negotiation-quote" element={
          <ProtectedRoute allowedRoles={[USER_ROLES.ADMIN, USER_ROLES.PURCHASER]} fallbackPath="/dashboard">
            <NegotiationQuotePage />
          </ProtectedRoute>
        } />
        <Route path="/create-request" element={
          <ProtectedRoute allowedRoles={[USER_ROLES.ADMIN, USER_ROLES.USER, USER_ROLES.PURCHASER]} fallbackPath="/dashboard">
            <CreateRequestPage />
          </ProtectedRoute>
        } />
        <Route path="/request-tracking" element={
          <ProtectedRoute allowedRoles={[USER_ROLES.ADMIN, USER_ROLES.USER, USER_ROLES.PURCHASER]} fallbackPath="/dashboard">
            <RequestTrackingPage />
          </ProtectedRoute>
        } />
        <Route path="/request-info" element={
          <ProtectedRoute allowedRoles={[USER_ROLES.ADMIN, USER_ROLES.USER, USER_ROLES.PURCHASER]} fallbackPath="/dashboard">
            <RequestInfoPage />
          </ProtectedRoute>
        } />
        <Route path="/item-quote-report" element={
          <ProtectedRoute allowedRoles={[USER_ROLES.ADMIN, USER_ROLES.USER, USER_ROLES.PURCHASER]} fallbackPath="/dashboard">
            <ItemQuoteReportPage />
          </ProtectedRoute>
        } />
      </Routes>
    </BrowserRouter>
  );
};
